import { useSelector } from 'react-redux'

const CampaignAdvancedOptionsSummary = () => {
  const {
    form: { traceUrlYn, dailyBudgetYn, dailyBudgetAmount },
  } = useSelector(state => state.ad.campaign)
  return (
    <p className="desc_box">
      <strong>추적 URL</strong> - {traceUrlYn === 'Y' ? '설정' : '미설정'} /{' '}
      <strong>일 예산</strong> -{' '}
      {dailyBudgetYn === 'N' || dailyBudgetAmount === ''
        ? '미설정'
        : `${dailyBudgetAmount.toLocaleString()}원`}
    </p>
  )
}
export default CampaignAdvancedOptionsSummary
